import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { DimeState } from './../state';
import { logDimeEvent } from './../telemetry';
export var preloadDimeExperience = function (experienceConfig) {
    if (!DimeState.dime) {
        return;
    }
    performance.mark('DimePreload_Start');
    var dimeExperience = experienceConfig.experiences.toString();
    logDimeEvent({
        eventName: KnownInstrumentationEvents.DimePreload,
        dimeExperience: dimeExperience,
        result: 'Start',
    });
    DimeState.dime.preload(experienceConfig).catch(function (err) {
        logDimeEvent({
            eventName: KnownInstrumentationEvents.DimePreload,
            dimeExperience: dimeExperience,
            result: 'Failed',
            metaData: err && typeof err === 'object' ? err : undefined,
        });
    });
};
//# sourceMappingURL=preloadDimeExperience.js.map